import { render, staticRenderFns } from "./EditPasswordDialog.vue?vue&type=template&id=a0317eb6&scoped=true"
import script from "./EditPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./EditPasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditPasswordDialog.vue?vue&type=style&index=0&id=a0317eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0317eb6",
  null
  
)

export default component.exports